import { LitElement, html, css } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { ComponentVariant } from '../types'

@customElement('e-text')
export class EText extends LitElement {
    @property({ type: String, reflect: true }) textType: 'heading' | 'subheading' | 'body' = 'body'
    @property({ type: String, reflect: true }) variant?: ComponentVariant
    @property({ type: String }) color: string = 'inherit'

    static styles = css`
        :host {
            display: inline-flex;
            box-sizing: border-box;
            align-items: center;
            margin: 0;
            font-family: var(--base-font-family, sans-serif);
            color: var(--text-primary);
        }

        :host([textType='heading']) {
            font-size: var(--font-size-h3);
            font-weight: 500;
            min-height: var(--control-height);
            line-height: 1.2;
        }

        :host([textType='subheading']) {
            font-size: var(--font-size-h4);
            font-weight: 500;
        }

        :host([textType='body']) {
            font-size: var(--font-size-body, var(--s1));
        }

        :host([textType='label']) {
            font-size: var(--font-size-body);
            font-weight: normal;
            min-height: var(--control-height);
            line-height: 1.2;
        }

        :host([variant='accent']) {
            color: var(--primary-color);
        }

        :host([variant='playful']) {
            color: var(--interactive-color);
        }

        :host([variant='gradient']) {
            color: transparent;
            background: linear-gradient(to right, var(--gradient-start), var(--gradient-end));
            -webkit-background-clip: text;
            background-clip: text;
        }
    `

    render() {
        if (this.color !== 'inherit') {
            this.style.color = this.color
        } else {
            this.style.color = ''
        }
        return html`
            <slot></slot>
        `
    }
}
